import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import IconGear from '../../../assets/icons/IconGear';
import MasterDataRolePermission from '../../../components/MasterData/MasterDataRolePermission';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_ROLE_INSERT } from '../../../constants/menuPermissionConstant';

class RoleAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleId: '',
            roleDescription: '',
            rolePermission: '',
            roleLevel: {
                data: [
                    {
                        value: 'nexsoft',
                        label: 'nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'distributor'
                    },
                    {
                        value: 'principal',
                        label: 'principal'
                    },
                    {
                        value: 'cso',
                        label: 'cso'
                    },
                ],
                selected: ''
            },
            permissionPage: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeRoleCategory = data => {
        this.setState({
            roleLevel: {
                ...this.state.roleLevel,
                selected: data.value
            }
        })
    }

    handleTogglePermission = () => {
        this.setState({
            permissionPage: !this.state.permissionPage
        })
    }

    handleCheckbox = data => {
        this.setState({
            rolePermission: data,
            permissionPage: !this.state.permissionPage
        })
    }

    handleSubmit = () => {
        const data = {
            role_id: this.state.roleId,
            permission: JSON.stringify(this.state.rolePermission),
            description: this.state.roleDescription,
            level: this.state.roleLevel.selected
        }

        API_MASTER_DATA.postDataRole(data, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                })
                setTimeout(() => {
                    this.setState({ showSuccessAlert: false })
                    this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_ROLE)
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_INSERT]} userPermission={this.props.userDetail.permissions}>
                <div className={this.state.permissionPage ? "block" : "hidden"}>
                    <MasterDataRolePermission
                        action="add"
                        handleTogglePermission={this.handleTogglePermission}
                        handleCheckbox={this.handleCheckbox}
                    />
                </div>

                <div className={this.state.permissionPage ? "hidden" : "role-container"}>
                    <div className="role-add">
                        <div className="flex justify-between">
                            <div></div>
                            <button type="button" id="btnpermission" className="rounded-full bg-white text-darkblue border-2 border-white font-bold px-5 py-2 ml-auto mb-3 flex items-center" onClick={() => this.handleTogglePermission()}>
                                <div className="bg-darkblue rounded-full flex justify-center items-center h-5 w-5 p-1">
                                    <IconGear />
                                </div>
                                <div className="ml-1">
                                    Izin Pengaturan
                                </div>
                            </button>
                        </div>
                        <WhiteContainer>
                            <div className="flex">
                                <div className="w-1/2 p-10 kiri">
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right flex justify-end">
                                            <label className="select-none font-medium mr-1" htmlFor="tslroleid">Role ID</label>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <div className="w-5/6">
                                            <input
                                                type="text"
                                                id="tslroleid"
                                                name="roleId"
                                                className="form-control"
                                                placeholder="Tulis Role ID"
                                                onChange={this.handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right flex justify-end">
                                            <label className="select-none font-medium mr-1" htmlFor="tmlroledescription">Deskripsi</label>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <div className="w-5/6">
                                            <textarea
                                                id="tmlroledescription"
                                                name="roleDescription"
                                                className="form-control resize-none h-48 2xl:h-40"
                                                placeholder="Tulis Deskripsi"
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right flex justify-end">
                                            <label className="select-none font-medium mr-1" htmlFor="ddsrolecategory">Kategori Role</label>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <div className="w-5/6">
                                            <Select
                                                id="ddsrolecategory"
                                                placeholder="Pilih Kategori"
                                                options={this.state.roleLevel.data}
                                                onChange={this.handleChangeRoleCategory}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute bottom-5 right-5">
                                <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_ROLE)}>Batal</button>
                                <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleSubmit()}>Simpan</button>
                            </div>
                        </WhiteContainer>
                    </div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Membuat Role Baru!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleAdd);